// eslint-disable-next-line @typescript-eslint/naming-convention
const __uriEncodeNotEscaped = {'!': '%21', '*': '%2A', '\'': '%27', '(': '%28', ')': '%29'};
const __uriEncodeNotEscapedSub = (a: '!' | '*' | '\'' | '(' | ')'): string => __uriEncodeNotEscaped[a];

// TODO: look into this issue with some characters not being encoded correctly
export const superSafeURLEncode = (code: string): string => encodeURIComponent(code)
  .replace(/[!\*'\(\)]/g, __uriEncodeNotEscapedSub);
export const superSafeURLDecode = (id: string): string => decodeURIComponent(id);


export const list2oxfordComma = (list: string[]): string => {
  let message = '';

  if (list.length > 2) {
    message += list.slice(0, list.length - 1).reduce((acc, current): string => acc + ', ' + current);
    message += ', & ' + list[list.length - 1];
  } else if (list.length === 2) {
    message += list[0] + ' & ' + list[1];
  } else {
    message += list[0];
  }
  return message;
};

// export const intersection = (arrays: any[][]) => {
//   const [index, short] = arrays.reduce((acc, cur, idx) => acc && acc[1].length < cur.length ? acc : [idx, cur]);
//   arrays = arrays.filter((v, i) => i !== index);
//   return short.filter((v) => {
//     for (const a of arrays) {
//       if (!a.includes(v)) {
//         return false;
//       }
//     }
//     return true;
//   });
// };

export const leadingZero = (value: string | number, minLength = 2): string => {
  value = '' + value;

  for (let i = 0; i < Math.max(0, minLength - (value).length); i++) {
    value = '0' + value;
  }
  return value;
};

export const integerSplit = (n, d): number[] => {
  n = Math.floor(n);
  const tens = Math.pow(10, d);
  const dec = n / tens;
  const f = Math.floor(dec);
  return [f * tens, Math.round((dec - f) * tens)];
};

export const EMAIL_REG = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@/.source +
  /((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.source);

export const validEmail = (email: string): boolean => EMAIL_REG.test(email);

const RE_THOUSANDS = /(?<!\..*)(\d)(?=(?:\d{3})+(?:\.|$))/g;
export const formatThousands = (num: number, decimals = 2, sep = ' '): string =>
  num.toFixed(decimals).replace(RE_THOUSANDS, `$1${sep}`);

// @ts-ignore
const RE_FLOOR_2_2_DEC = new RegExp('^-?\\d+(?:\.\\d{0,' + (2 || -1) + '})?');
export const floor2Dec = (v: number): number => +v.toString().match(RE_FLOOR_2_2_DEC)[0];
